import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, getIn } from 'formik';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { FormField } from 'core/components/form';
import { Label } from 'core/components/label';
import { Card } from 'core/components/card';
import { getButtonLabel } from '../helpers';
import { NotificationCard } from 'core/components/notification-card';

import styles from './policy-change-actions.styles';

const FARM_POLICY_ACTION_OPTIONS = [
  { value: 'draft', label: 'Draft and keep changing' },
  { value: 'complete', label: 'Complete the policy change' }
];

function PolicyChangeActions({ classes, isFarmPolicy, onClose, disableInternalNote, action, preview }) {
  const { values } = useFormikContext();

  const actionValue = getIn(values, 'farmPolicyAction');

  if (isFarmPolicy) {
    return (
      <Grid item xs={12}>
        <Card type="primaryEditable" className={classes.farmPolicyCard}>
          <Label className={classes.farmPolicyTitle}>What would you like to do next?</Label>
          <Label className={classes.farmPolicySubtitle}>Please select an option</Label>
          <FormField
            id="farmPolicyAction"
            name="farmPolicyAction"
            type="radio"
            options={FARM_POLICY_ACTION_OPTIONS}
            optionsSideBySide={false}
            showDividers
            className={classes.farmPolicyRadioGroup}
            ignoreGlobalDisabledState
            showError={false}
          />
          {preview.needsUnderwritingReview && actionValue === 'complete' && (
            <NotificationCard className={classes.notification} iconSize="icon16" type="infoGreen">
              <Grid container className={classes.rceValues}>
                <Label>One or more changes made requires underwriting approval.</Label>
              </Grid>
            </NotificationCard>
          )}
          {actionValue === 'complete' && !preview.needsUnderwritingReview && (
            <FormField
              id="internalNote"
              name="internalNote"
              type="string"
              label="Add an internal note"
              mode="light"
              xs={12}
              ignoreGlobalDisabledState
              permissions={{ isLicensedAction: false }}
              disabled={disableInternalNote}
            />
          )}
          <div className={classes.farmPolicyButtons}>
            <Button type="button" variant="contained" className={classes.cancelButton} onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="primary" className={classes.savePolicyButton}>
              {getButtonLabel(actionValue, { needsUnderwritingReview: preview.needsUnderwritingReview })}
            </Button>
          </div>
        </Card>
      </Grid>
    );
  }

  return (
    <>
      <Grid item xs={12}>
        <div className={classes.noteRow}>
          <FormField
            id="internalNote"
            name="internalNote"
            type="string"
            label="Add an internal note"
            mode="light"
            ignoreGlobalDisabledState
            permissions={{ isLicensedAction: false }}
            disabled={disableInternalNote}
          />
          <Button id="submit" name="submit" type="submit" variant="contained" color="primary">
            {getButtonLabel(action)}
          </Button>
        </div>
      </Grid>
    </>
  );
}

PolicyChangeActions.propTypes = {
  classes: PropTypes.object.isRequired,
  isFarmPolicy: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  disableInternalNote: PropTypes.bool,
  action: PropTypes.oneOf(['cancel', 'reinstate', 'rescind', '']),
  preview: PropTypes.object.isRequired
};

PolicyChangeActions.defaultProps = {
  disableInternalNote: false,
  action: ''
};

export default withStyles(styles)(PolicyChangeActions);
